import { render, staticRenderFns } from "./PropertySelectMultipleColoredOption.vue?vue&type=template&id=16472dae&"
import script from "./PropertySelectMultipleColoredOption.vue?vue&type=script&lang=js&"
export * from "./PropertySelectMultipleColoredOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports